import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import { ArrowRightIcon } from "../../Assets/images/svgs";
import { Title } from "../../Components/Atoms"; 
import { Bar } from "../../Components/Organisms/Graphs";
import PATHS from "../../Routes/paths";
import { MODULE_TYPES, STATS_ENUMS } from "../../Library/widgets";

const ThrottlePercent = ({ data }) => {
  const navigate = useNavigate();
  const parser = { x: "label", y: "count", yUnit: "km" };

  const graphData = useMemo(() => {
    const throttleData = data[MODULE_TYPES.THROTTLE_PERCENT] || [];
    const throttleEnum = STATS_ENUMS[MODULE_TYPES.THROTTLE_PERCENT];

    const processedData = throttleData.map((d) => {
      const cycle = throttleEnum[d._id] || {};
      return { id: d._id, label: cycle.label, count: (d.dst / 1000).toFixed(2), color: cycle.color };
    });

    processedData.sort((a, b) => a.id - b.id);
    return processedData;
  }, [ data ]);

  return (
    <div className="widget-group widget-1">
      <article className="widget-main">
        <header className="widget-header">
          <Title variant="md" fixed>Throttle Percentage</Title>
        </header>

        <main className="widget-section">
          <div className="widget-chart">
            <Bar title="Throttle Percentage" parser={parser} data={graphData} />
          </div>

          <div className="widget-link">
            <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => navigate(PATHS.THROTTLE_PERCENT)}>
              View Reports
            </Button>
          </div>
        </main>
      </article>
    </div>
  );
};

export default ThrottlePercent;
